export const TAX_JV_REQUEST  = 'TAX_JV_REQUEST';
export const TAX_JV_REQUEST_SUCCESS  = 'TAX_JV_REQUEST_SUCCESS';
export const TAX_JV_REQUEST_FAILURE  = 'TAX_JV_REQUEST_FAILURE';